/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvTranDetInsertModel { 
    guid?: string | null;
    itemNumber?: string | null;
    itemDescription?: string | null;
    uOfM?: string | null;
    units?: number;
    quantity?: number;
    unitPrice?: number | null;
    amount?: number | null;
    itemState?: number | null;
    workOrderId?: number;
    uniqueIdentifierType?: number | null;
    uniqueIdentifier?: string | null;
    batchIdentifierType?: number | null;
    batchIdentifier?: string | null;
    sellByDate?: string | null;
    reference?: string | null;
    barcodeSource?: string | null;
    linkCustomerOrderDetId?: number | null;
    gtinFormat?: string | null;
    readonly uniqueIdentifierTypeDisplay?: string | null;
    readonly batchIdentifierTypeDisplay?: string | null;
    validateItemIdentifier?: boolean;
    weightType?: string | null;
}

